<template>
  <div class="assets-offline-list" ref="assetsOfflineList">
    <assets-offline-map
        :map-config="mapConfig"
        :show-filters="true"
        :can-import="canImport"
        :can-export="true"
        fetch-on="pan"
        :fetch-params="{ status: 'all', include_archived: 1 }"
        mode="list"
        ref="assetsOfflineMap"
    />
  </div>
</template>

<script>

    import AssetsOfflineMap from "@/components/AssetsOfflineMap";

    export default {
      components: {
        AssetsOfflineMap
      },
      data: () => ({
        mapConfig: {
          height: 450,
          devToolsPosition: "left",
          // hasDrawControl: true,
          // hasDrawToggleControl: true,
        }
      }),
      mounted() {
        this.mapConfig.height = this.$refs.assetsOfflineList.clientHeight;
      },
      computed:{
        canImport() {
          let canImport =  this.$store.state.Auth.user.permissions.find(
            permission => permission.name === "can import assets"
          );

          if(canImport) return true

          return false
        }
      }
    };

</script>

<style scoped>
.assets-offline-list {
  height: calc(100vh - 6.5rem);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AssetsOffline/list/index.vue